export const STATE_CONFIG = {
    "AR": {
        "stateList": [
            {"key": "BA", "value": "Buenos Aires"},
            {"key": "CT", "value": "Catamarca"},
            {"key": "CC", "value": "Chaco"},
            {"key": "CH", "value": "Chubut"},
            {"key": "CF", "value": "Ciudad de Buenos Aires"},
            {"key": "CB", "value": "Córdoba"},
            {"key": "CN", "value": "Corrientes"},
            {"key": "ER", "value": "Entre Ríos"},
            {"key": "FM", "value": "Formosa"},
            {"key": "JY", "value": "Jujuy"},
            {"key": "LP", "value": "La Pampa"},
            {"key": "LR", "value": "La Rioja"},
            {"key": "MZ", "value": "Mendoza"},
            {"key": "MN", "value": "Misiones"},
            {"key": "NQ", "value": "Neuquén"},
            {"key": "RN", "value": "Río Negro"},
            {"key": "SA", "value": "Salta"},
            {"key": "SJ", "value": "San Juan"},
            {"key": "SL", "value": "San Luis"},
            {"key": "SC", "value": "Santa Cruz"},
            {"key": "SF", "value": "Santa Fe"},
            {"key": "SE", "value": "Santiago del Estero"},
            {"key": "TF", "value": "Tierra del Fuego"},
            {"key": "TM", "value": "Tucumán"}
        ]
    },
    "AU": {
        "stateList": [
            {"key": "ACT", "value": "AUSTRALIAN CAPITAL TERRITORY"},
            {"key": "NSW", "value": "NEW SOUTH WALES"},
            {"key": "NT", "value": "NORTHERN TERRITORY - AUSTRALIA"},
            {"key": "QLD", "value": "QUEENSLAND"},
            {"key": "SA", "value": "SOUTHERN AUSTRALIA"},
            {"key": "TAS", "value": "TASMANIA"},
            {"key": "VIC", "value": "VICTORIA"},
            {"key": "WA", "value": "WESTERN AUSTRALIA"}
        ]
    },
    "BR": {
        "stateList": [
            {"key": "TO", "value": "TOCANTINS"},
            {"key": "PI", "value": "PIAUI"},
            {"key": "SC", "value": "SANTA CATARINA"},
            {"key": "RN", "value": "RIO GRANDE DO NORTE"},
            {"key": "MS", "value": "MATO GROSSO DO SUL"},
            {"key": "SE", "value": "SERGIPE"},
            {"key": "RO", "value": "RONDONIA"},
            {"key": "MT", "value": "MATO GROSSO"},
            {"key": "CE", "value": "CEARA"},
            {"key": "SP", "value": "SAO PAULO"},
            {"key": "AC", "value": "ACRE"},
            {"key": "RR", "value": "RORAIMA"},
            {"key": "RS", "value": "RIO GRANDE DO SUL"},
            {"key": "GO", "value": "GOIAS"},
            {"key": "MA", "value": "MARANHAO"},
            {"key": "PR", "value": "PARANA"},
            {"key": "BA", "value": "BAHIA"},
            {"key": "AL", "value": "ALAGOAS"},
            {"key": "MG", "value": "MINAS GERAIS"},
            {"key": "PA", "value": "PARA"},
            {"key": "AM", "value": "AMAZONAS"},
            {"key": "DF", "value": "DISTRITO FEDERAL"},
            {"key": "ES", "value": "ESPIRITO SANTO"},
            {"key": "BP", "value": "PARAIBA"},
            {"key": "AP", "value": "AMAPA"},
            {"key": "PE", "value": "PERNAMBUCO"},
            {"key": "BH", "value": "BAHIA"},
            {"key": "RJ", "value": "RIO DE JANEIRO"}
        ]
    },
    "CA": {
        "stateList": [
            {"key": "AB", "value": "ALBERTA"},
            {"key": "QC", "value": "QUEBEC"},
            {"key": "BC", "value": "BRITISH COLUMBIA"},
            {"key": "MB", "value": "MANITOBA"},
            {"key": "SK", "value": "SASKATCHEWAN"},
            {"key": "LB", "value": "LABRADOR"},
            {"key": "YT", "value": "YUKON TERRITORIES"},
            {"key": "NS", "value": "NOVA SCOTIA"},
            {"key": "NB", "value": "NEW BRUNSWICK"},
            {"key": "NT", "value": "NORTHERN TERRITORIES"},
            {"key": "NL", "value": "NEWFOUNDLAND"},
            {"key": "ON", "value": "ONTARIO"},
            {"key": "PE", "value": "PRICE EDWARD ISLAND"}
        ]
    },
    "CL": {
        "stateList": [
            {"key": "AI", "value": "Aisén del General Carlos Ibáñez del Campo"},
            {"key": "AN", "value": "Antofagasta"},
            {"key": "AR", "value": "Araucanía"},
            {"key": "AP", "value": "Arica y Parinacota"},
            {"key": "AT", "value": "Atacama"},
            {"key": "BI", "value": "Bío-Bío"},
            {"key": "CO", "value": "Coquimbo"},
            {"key": "LI", "value": "Libertador General Bernardo O'Higgins"},
            {"key": "LL", "value": "Los Lagos"},
            {"key": "LR", "value": "Los Ríos"},
            {"key": "MA", "value": "Magallanes"},
            {"key": "ML", "value": "Maule"},
            {"key": "RM", "value": "Región Metropolitana de Santiago"},
            {"key": "TA", "value": "Tarapacá"},
            {"key": "VS", "value": "Valparaíso"}
        ]
    },
    "CO": {
        "stateList": [
            {"key": "AMA", "value": "Amazonas"},
            {"key": "ANT", "value": "Antioquia"},
            {"key": "ARA", "value": "Arauca"},
            {"key": "ATL", "value": "Atlántico"},
            {"key": "BOL", "value": "Bolívar"},
            {"key": "BOY", "value": "Boyacá"},
            {"key": "CAL", "value": "Caldas"},
            {"key": "CAQ", "value": "Caquetá"},
            {"key": "CAS", "value": "Casanare"},
            {"key": "CAU", "value": "Cauca"},
            {"key": "CES", "value": "Cesar"},
            {"key": "CHO", "value": "Chocó"},
            {"key": "COR", "value": "Córdoba"},
            {"key": "CUN", "value": "Cundinamarca"},
            {"key": "DC", "value": "Distrito Capital"},
            {"key": "GUA", "value": "Guainía"},
            {"key": "GUV", "value": "Guaviare"},
            {"key": "HUI", "value": "Huila"},
            {"key": "LAG", "value": "La Guajira"},
            {"key": "MAG", "value": "Magdalena"},
            {"key": "MET", "value": "Meta"},
            {"key": "NAR", "value": "Nariño"},
            {"key": "NSA", "value": "Norte de Santander"},
            {"key": "PUT", "value": "Putumayo"},
            {"key": "QUI", "value": "Quindío"},
            {"key": "RIS", "value": "Risaralda"},
            {"key": "SAN", "value": "Santander"},
            {"key": "SAP", "value": "San Andrés y Provide"},
            {"key": "SUC", "value": "Sucre"},
            {"key": "TOL", "value": "Tolima"},
            {"key": "VAC", "value": "Valle del Cauca"},
            {"key": "VAU", "value": "Vaupés"},
            {"key": "VID", "value": "Vichada"}
        ]
    },
    "CR": {
        "stateList": [
            {"key": "AL", "value": "Alajuela"},
            {"key": "CA", "value": "Cartago"},
            {"key": "GU", "value": "Guanacaste"},
            {"key": "HR", "value": "Heredia"},
            {"key": "LM", "value": "Limón"},
            {"key": "PA", "value": "Puntarenas"},
            {"key": "SJ", "value": "San José"}
        ]
    },
    "GT": {
        "stateList": [
            {"key": "AV", "value": "Alta Verapaz"},
            {"key": "BV", "value": "Baja Verapaz"},
            {"key": "CM", "value": "Chimaltenango"},
            {"key": "CQ", "value": "Chiquimula"},
            {"key": "PE", "value": "Petén"},
            {"key": "EL", "value": "El Progreso"},
            {"key": "QC", "value": "Quiché"},
            {"key": "ES", "value": "Escuintla"},
            {"key": "GT", "value": "Guatemala"},
            {"key": "HU", "value": "Huehuetenango"},
            {"key": "IZ", "value": "Izabal"},
            {"key": "JA", "value": "Jalapa"},
            {"key": "JU", "value": "Jutiapa"},
            {"key": "QZ", "value": "Quetzaltenango"},
            {"key": "RE", "value": "Retalhuleu"},
            {"key": "SA", "value": "Sacatepéquez"},
            {"key": "SM", "value": "San Marcos"},
            {"key": "SR", "value": "Santa Rosa"},
            {"key": "SO", "value": "Sololá"},
            {"key": "SU", "value": "Suchitepéquez"},
            {"key": "TO", "value": "Totonicapán"},
            {"key": "ZA", "value": "Zacapa"}
        ]
    },
    "HN": {
        "stateList": [
            {"key": "XX", "value": " "},
            {"key": "AT", "value": "Atlántida"},
            {"key": "CH", "value": "Choluteca"},
            {"key": "CL", "value": "Colón"},
            {"key": "CM", "value": "Comayagua"},
            {"key": "CP", "value": "Copán"},
            {"key": "CR", "value": "Cortés"},
            {"key": "EP", "value": "El Paraíso"},
            {"key": "FM", "value": "Francisco Morazán"},
            {"key": "GD", "value": "Gracias a Dios"},
            {"key": "IN", "value": "Intibucá"},
            {"key": "IB", "value": "Islas de la Bahía"},
            {"key": "LP", "value": "La Paz"},
            {"key": "LE", "value": "Lempira"},
            {"key": "OC", "value": "Ocotepeque"},
            {"key": "OL", "value": "Olancho"},
            {"key": "SB", "value": "Santa Bárbara"},
            {"key": "VA", "value": "Valle"},
            {"key": "YO", "value": "Yoro"}
        ]
    },
    "JP": {
        "stateList": [
            {"key": "01", "value": "北海道"},
            {"key": "02", "value": "青森県"},
            {"key": "03", "value": "岩手県"},
            {"key": "04", "value": "宮城県"},
            {"key": "05", "value": "秋田県"},
            {"key": "06", "value": "山形県"},
            {"key": "07", "value": "福島県"},
            {"key": "08", "value": "茨城県"},
            {"key": "09", "value": "栃木県"},
            {"key": "10", "value": "群馬県"},
            {"key": "11", "value": "埼玉県"},
            {"key": "12", "value": "千葉県"},
            {"key": "13", "value": "東京都"},
            {"key": "14", "value": "神奈川県"},
            {"key": "15", "value": "新潟県"},
            {"key": "16", "value": "富山県"},
            {"key": "17", "value": "石川県"},
            {"key": "18", "value": "福井県"},
            {"key": "19", "value": "山梨県"},
            {"key": "20", "value": "長野県"},
            {"key": "21", "value": "岐阜県"},
            {"key": "22", "value": "静岡県"},
            {"key": "23", "value": "愛知県"},
            {"key": "24", "value": "三重県"},
            {"key": "25", "value": "滋賀県"},
            {"key": "26", "value": "京都府"},
            {"key": "27", "value": "大阪府"},
            {"key": "28", "value": "兵庫県"},
            {"key": "29", "value": "奈良県"},
            {"key": "30", "value": "和歌山県"},
            {"key": "31", "value": "鳥取県"},
            {"key": "32", "value": "島根県"},
            {"key": "33", "value": "岡山県"},
            {"key": "34", "value": "広島県"},
            {"key": "35", "value": "山口県"},
            {"key": "36", "value": "徳島県"},
            {"key": "37", "value": "香川県"},
            {"key": "38", "value": "愛媛県"},
            {"key": "39", "value": "高知県"},
            {"key": "40", "value": "福岡県"},
            {"key": "41", "value": "佐賀県"},
            {"key": "42", "value": "長崎県"},
            {"key": "43", "value": "熊本県"},
            {"key": "44", "value": "大分県"},
            {"key": "45", "value": "宮崎県"},
            {"key": "46", "value": "鹿児島県"},
            {"key": "47", "value": "沖縄県"}
        ]
    },
    "MX": {
        "stateList": [
            {"key": "AGU", "value": "AGUASCALIENTES"},
            {"key": "BCN", "value": "BAJA CALIFORNIA"},
            {"key": "BCS", "value": "BAJA CALIFORNIA SUR"},
            {"key": "CAM", "value": "CAMPECHE"},
            {"key": "CMX", "value": "CDMX"},
            {"key": "CHIA", "value": "CHIAPAS"},
            {"key": "CHIH", "value": "CHIHUAHUA"},
            {"key": "COAH", "value": "COAHUILA"},
            {"key": "COL", "value": "COLIMA"},
            {"key": "DUR", "value": "DURANGO"},
            {"key": "MEX", "value": "ESTADO DE MEXICO"},
            {"key": "GUA", "value": "GUANAJUATO"},
            {"key": "GUE", "value": "GUERRERO"},
            {"key": "HID", "value": "HIDALGO"},
            {"key": "JAL", "value": "JALISCO"},
            {"key": "MICH", "value": "MICHOACAN"},
            {"key": "MOR", "value": "MORELOS"},
            {"key": "NAY", "value": "NAYARIT"},
            {"key": "NL", "value": "NUEVO LEON"},
            {"key": "OAX", "value": "OAXACA"},
            {"key": "PUE", "value": "PUEBLA"},
            {"key": "QUE", "value": "QUERETARO"},
            {"key": "QR", "value": "QUINTANA ROO"},
            {"key": "SLP", "value": "SAN LUIS POTOSI"},
            {"key": "SIN", "value": "SINALOA"},
            {"key": "SON", "value": "SONORA"},
            {"key": "TAB", "value": "TABASCO"},
            {"key": "TAM", "value": "TAMAULIPAS"},
            {"key": "TLA", "value": "TLAXCALA"},
            {"key": "VER", "value": "VERACRUZ"},
            {"key": "YUC", "value": "YUCATAN"},
            {"key": "ZAC", "value": "ZACATECAS"}
        ]
    },
    "NZ": {
        "stateList": [
            {"key": "ALD", "value": "Auckland"},
            {"key": "BOP", "value": "Bay of Plenty"},
            {"key": "CAN", "value": "Canterbury"},
            {"key": "GIS", "value": "Gisborne"},
            {"key": "HB", "value": "Hawke's Bay"},
            {"key": "MRL", "value": "Marlborough"},
            {"key": "MW", "value": "Manawatu-Wanganui"},
            {"key": "NEL", "value": "Nelson"},
            {"key": "NLD", "value": "Northland"},
            {"key": "OTA", "value": "Otago"},
            {"key": "SLD", "value": "Southland"},
            {"key": "TKI", "value": "Taranaki"},
            {"key": "TSN", "value": "Tasman"},
            {"key": "WAI", "value": "Waikato"},
            {"key": "WC", "value": "West Coast"},
            {"key": "WEL", "value": "Wellington"}
        ]
    },
    "PE": {
        "stateList": [
            {"key": "AMA", "value": "Amazonas"},
            {"key": "ANC", "value": "Áncash"},
            {"key": "APU", "value": "Apurímac"},
            {"key": "ARE", "value": "Arequipa"},
            {"key": "AYA", "value": "Ayacucho"},
            {"key": "CAJ", "value": "Cajamarca"},
            {"key": "CAL", "value": "Callao"},
            {"key": "CUS", "value": "Cusco"},
            {"key": "HUV", "value": "Huancavelica"},
            {"key": "HUC", "value": "Huánuco"},
            {"key": "ICA", "value": "Ica"},
            {"key": "JUN", "value": "Junín"},
            {"key": "LAL", "value": "La Libertad"},
            {"key": "LAM", "value": "Lambayeque"},
            {"key": "LIM", "value": "Lima"},
            {"key": "LOR", "value": "Loreto"},
            {"key": "MDD", "value": "Madre de Dios"},
            {"key": "MOQ", "value": "Moquegua"},
            {"key": "PAS", "value": "Pasco"},
            {"key": "PIU", "value": "Piura"},
            {"key": "PUN", "value": "Puno"},
            {"key": "SAM", "value": "San Martín"},
            {"key": "TAC", "value": "Tacna"},
            {"key": "TUM", "value": "Tumbes"},
            {"key": "UCA", "value": "Ucayali"}
        ]
    },
    "RU": {
        "stateList": [
            {"key": "-", "value": "-"},
            {"key": "HK", "value": "Хакасия Республика|Абакан"},
            {"key": "AG", "value": "Агинский Бурятский|Агинское"},
            {"key": "CU", "value": "Чукотский АО|Анадырь"},
            {"key": "AR", "value": "Архангельская|Архангельск"},
            {"key": "AS", "value": "Астраханская|Астрахань"},
            {"key": "AY", "value": "Алтайский край|Барнаул"},
            {"key": "BL", "value": "Белгородская|Белгород"},
            {"key": "EV", "value": "Еврейская автон|Биробиджан"},
            {"key": "AM", "value": "Амурская область|Благовещенск"},
            {"key": "BR", "value": "Брянская область|Брянск"},
            {"key": "NV", "value": "Новгородская|Великий Новгород"},
            {"key": "PR", "value": "Приморский край|Владивосток"},
            {"key": "OS", "value": "Северная Осетия|Владикавказ"},
            {"key": "VD", "value": "Владимирская|Владимир"},
            {"key": "VL", "value": "Волгоградская|Волгоград"},
            {"key": "VG", "value": "Вологодская|Вологда"},
            {"key": "VJ", "value": "Воронежская|Воронеж"},
            {"key": "AL", "value": "Алтай Республика|Горно-Алтайск"},
            {"key": "CE", "value": "Чеченская Респуб|Грозный"},
            {"key": "DN", "value": "Таймырский АО|Дудинка"},
            {"key": "SV", "value": "Свердловская|Екатеринбург"},
            {"key": "IV", "value": "Ивановская область|Иваново"},
            {"key": "UD", "value": "Удмуртия|Ижевск"},
            {"key": "IR", "value": "Иркутская область|Иркутск"},
            {"key": "ME", "value": "Марий Эл|Йошкар-Ола"},
            {"key": "TR", "value": "Татарстан|Казань"},
            {"key": "KA", "value": "Калининградская|Калининград"},
            {"key": "KJ", "value": "Калужская область|Калуга"},
            {"key": "KE", "value": "Кемеровская|Кемерово"},
            {"key": "KV", "value": "Кировская область|Киров"},
            {"key": "KO", "value": "Костромская область|Кострома"},
            {"key": "KD", "value": "Краснодарский край|Краснодар"},
            {"key": "KY", "value": "Красноярский крайКрасноярск"},
            {"key": "KU", "value": "Курганская область|Курган"},
            {"key": "KS", "value": "Курская область|Курск"},
            {"key": "TA", "value": "Тыва Республика|Кызыл"},
            {"key": "LP", "value": "Липецкая область|Липецк"},
            {"key": "MG", "value": "Магаданская|Магадан"},
            {"key": "IN", "value": "Ингушетия|Магас"},
            {"key": "AD", "value": "Адыгея Республика|Майкоп"},
            {"key": "DG", "value": "Дагестан|Махачкала"},
            {"key": "MS", "value": "Московская область|Москва"},
            {"key": "MU", "value": "Мурманская область|Мурманск"},
            {"key": "KB", "value": "Кабардино-Балкария Республика|Нальчик"},
            {"key": "NE", "value": "Ненецкий АО|Нарьян-Мар"},
            {"key": "NJ", "value": "Нижегородская|Нижний Новгород"},
            {"key": "NO", "value": "Новосибирская|Новосибирск"},
            {"key": "OM", "value": "Омская область|Омск"},
            {"key": "OL", "value": "Орловская область|Орел"},
            {"key": "OR", "value": "Оренбургская|Оренбург"},
            {"key": "CR", "value": "Корякский АО|Палана"},
            {"key": "PE", "value": "Пензенская область|Пенза"},
            {"key": "PM", "value": "Пермский край|Пермь"},
            {"key": "KR", "value": "Карелия Республика|Петрозаводск"},
            {"key": "KM", "value": "Камчатский край|Петропавловск-Камчатский"},
            {"key": "PS", "value": "Псковская область|Псков"},
            {"key": "RS", "value": "Ростовская область|Ростов-на-Дону"},
            {"key": "RY", "value": "Рязанская область|Рязань"},
            {"key": "YN", "value": "Ямало-Ненецкий АО|Салехард"},
            {"key": "SM", "value": "Самарская область|Самара"},
            {"key": "LE", "value": "Ленинградская|Санкт-Петербург"},
            {"key": "MR", "value": "Мордовия|Саранск"},
            {"key": "SA", "value": "Саратовская область|Саратов"},
            {"key": "SL", "value": "Смоленская область|Смоленск"},
            {"key": "ST", "value": "Ставропольский край|Ставрополь"},
            {"key": "KI", "value": "Коми Республика|Сыктывкар"},
            {"key": "TM", "value": "Тамбовская область|Тамбов"},
            {"key": "TV", "value": "Тверская область|Тверь"},
            {"key": "TO", "value": "Томская область|Томск"},
            {"key": "TU", "value": "Тульская область|Тула"},
            {"key": "EN", "value": "Эвенкийский АО|Тура"},
            {"key": "TN", "value": "Тюменская область|Тюмень"},
            {"key": "BU", "value": "Бурятия Республика|Улан-Удэ"},
            {"key": "UL", "value": "Ульяновская область|Ульяновск"},
            {"key": "UO", "value": "Бурятский АО|Усть-Ордынский"},
            {"key": "BS", "value": "Башкортостан|Уфа"},
            {"key": "HB", "value": "Хабаровский край|Хабаровск"},
            {"key": "HA", "value": "Ханты-Мансийский|Ханты-Мансийск"},
            {"key": "CV", "value": "Чувашия|Чебоксары"},
            {"key": "CH", "value": "Челябинская|Челябинск"},
            {"key": "KC", "value": "Карачаево-Черкессия|Черкесск"},
            {"key": "CN", "value": "Читинская область|Чита"},
            {"key": "KL", "value": "Калмыкия Республика|Элиста"},
            {"key": "SH", "value": "Сахалинская область|Южно-Сахалинск"},
            {"key": "YT", "value": "Саха (Якутия)|Якутск"},
            {"key": "YA", "value": "Ярославская область|Ярославль"}
        ]
    },
    "SV": {
        "stateList": [
            {"key": "CA", "value": "Cabañas"},
            {"key": "CH", "value": "Chalatenango"},
            {"key": "CU", "value": "Cuscatlán"},
            {"key": "LI", "value": "La Libertad"},
            {"key": "MO", "value": "Morazán"},
            {"key": "PA", "value": "La Paz"},
            {"key": "SA", "value": "Santa Ana"},
            {"key": "SM", "value": "San Miguel"},
            {"key": "SO", "value": "Sonsonate"},
            {"key": "SS", "value": "San Salvador"},
            {"key": "SV", "value": "El Salvador"},
            {"key": "UN", "value": "La Unión"},
            {"key": "US", "value": "Usulután"}
        ]
    },
    "UA": {
        "stateList": [
            {"key": "CRI", "value": "Крим"},
            {"key": "VIN", "value": "Вінницька область"},
            {"key": "DKN", "value": "Днiпропетроська область"},
            {"key": "DOK", "value": "Донецька область"},
            {"key": "ZTR", "value": "Житомирська область"},
            {"key": "UDJ", "value": "Закарпатська область"},
            {"key": "OZH", "value": "Запорізька область"},
            {"key": "IFO", "value": "Івано-франківська область"},
            {"key": "IEV", "value": "Київська область"},
            {"key": "KGO", "value": "Кіровоградська область"},
            {"key": "VSG", "value": "Луганська область"},
            {"key": "LWO", "value": "Львівська область"},
            {"key": "NLV", "value": "Миколаївська область"},
            {"key": "ODS", "value": "Одеська область"},
            {"key": "PLV", "value": "Полтавська область"},
            {"key": "RWN", "value": "Рівненська область"},
            {"key": "UMY", "value": "Сумська область"},
            {"key": "TNL", "value": "Тернопільська область"},
            {"key": "HRK", "value": "Харківська область"},
            {"key": "KHE", "value": "Херсонська область"},
            {"key": "HMJ", "value": "Хмельницька область"},
            {"key": "CKC", "value": "Черкаська область"},
            {"key": "CWC", "value": "Чернівецька область"},
            {"key": "CEJ", "value": "Чернігівська область"},
            {"key": "UCK", "value": "Волинська область"}
        ]
    },
    "US": {
        "stateList": [
            {"key": "AA", "value": "AA"},
            {"key": "AE", "value": "AE"},
            {"key": "AK", "value": "AK"},
            {"key": "AL", "value": "AL"},
            {"key": "AP", "value": "AP"},
            {"key": "AR", "value": "AR"},
            {"key": "AS", "value": "AS"},
            {"key": "AZ", "value": "AZ"},
            {"key": "CA", "value": "CA"},
            {"key": "CO", "value": "CO"},
            {"key": "CT", "value": "CT"},
            {"key": "DC", "value": "DC"},
            {"key": "DE", "value": "DE"},
            {"key": "FL", "value": "FL"},
            {"key": "FM", "value": "FM"},
            {"key": "GA", "value": "GA"},
            {"key": "GU", "value": "GU"},
            {"key": "HI", "value": "HI"},
            {"key": "IA", "value": "IA"},
            {"key": "ID", "value": "ID"},
            {"key": "IL", "value": "IL"},
            {"key": "IN", "value": "IN"},
            {"key": "KS", "value": "KS"},
            {"key": "KY", "value": "KY"},
            {"key": "LA", "value": "LA"},
            {"key": "MA", "value": "MA"},
            {"key": "MD", "value": "MD"},
            {"key": "ME", "value": "ME"},
            {"key": "MH", "value": "MH"},
            {"key": "MI", "value": "MI"},
            {"key": "MN", "value": "MN"},
            {"key": "MO", "value": "MO"},
            {"key": "MP", "value": "MP"},
            {"key": "MS", "value": "MS"},
            {"key": "MT", "value": "MT"},
            {"key": "NC", "value": "NC"},
            {"key": "ND", "value": "ND"},
            {"key": "NE", "value": "NE"},
            {"key": "NH", "value": "NH"},
            {"key": "NJ", "value": "NJ"},
            {"key": "NM", "value": "NM"},
            {"key": "NV", "value": "NV"},
            {"key": "NY", "value": "NY"},
            {"key": "OH", "value": "OH"},
            {"key": "OK", "value": "OK"},
            {"key": "OR", "value": "OR"},
            {"key": "PA", "value": "PA"},
            {"key": "PR", "value": "PR"},
            {"key": "PW", "value": "PW"},
            {"key": "RI", "value": "RI"},
            {"key": "SC", "value": "SC"},
            {"key": "SD", "value": "SD"},
            {"key": "TN", "value": "TN"},
            {"key": "TX", "value": "TX"},
            {"key": "UT", "value": "UT"},
            {"key": "VA", "value": "VA"},
            {"key": "VI", "value": "VI"},
            {"key": "VT", "value": "VT"},
            {"key": "WA", "value": "WA"},
            {"key": "WI", "value": "WI"},
            {"key": "WV", "value": "WV"},
            {"key": "WY", "value": "WY"}
        ]
    },
    "VE": {
        "stateList": [
            {"key": "AM", "value": "Amazonas"},
            {"key": "AN", "value": "Anzoátegui"},
            {"key": "AP", "value": "Apure"},
            {"key": "AR", "value": "Aragua"},
            {"key": "BA", "value": "Barinas"},
            {"key": "BO", "value": "Bolívar"},
            {"key": "CA", "value": "Carabobo"},
            {"key": "CO", "value": "Cojedes"},
            {"key": "DF", "value": "Dist Federal"},
            {"key": "FA", "value": "Falcón"},
            {"key": "GU", "value": "Guárico"},
            {"key": "LA", "value": "Lara"},
            {"key": "ME", "value": "Mérida"},
            {"key": "MI", "value": "Miranda"},
            {"key": "MO", "value": "Monagas"},
            {"key": "NE", "value": "Nueva Esparta"},
            {"key": "PO", "value": "Portuguesa"},
            {"key": "SU", "value": "Sucre"},
            {"key": "TA", "value": "Táchira"},
            {"key": "TR", "value": "Trujillo"},
            {"key": "VA", "value": "Vargas"},
            {"key": "YA", "value": "Yaracuy"},
            {"key": "ZU", "value": "Zulia"}
        ]
    },
    "VN": {
        "stateList": [
            {"key": " ", "value": " "},
            {"key": "AGI", "value": "An Giang"},
            {"key": "BGI", "value": "Bắc Giang"},
            {"key": "BKA", "value": "Bắc Kạn"},
            {"key": "BLI", "value": "Bạc Liêu"},
            {"key": "BNI", "value": "Bắc Ninh"},
            {"key": "BRV", "value": "Bà Rịa-Vũng Tàu"},
            {"key": "BTR", "value": "Bến Tre"},
            {"key": "BDI", "value": "Bình Định"},
            {"key": "BDU", "value": "Bình Dương"},
            {"key": "BPH", "value": "Bình Phước"},
            {"key": "BTH", "value": "Bình Thuận"},
            {"key": "CMA", "value": "Cà Mau"},
            {"key": "CTH", "value": "Cần Thơ"},
            {"key": "CBA", "value": "Cao Bằng"},
            {"key": "DLA", "value": "Đắk Lắk"},
            {"key": "DNO", "value": "Đắk Nông"},
            {"key": "DNG", "value": "Đà Nẵng"},
            {"key": "DBI", "value": "Điện Biên"},
            {"key": "DNI", "value": "Đồng Nai"},
            {"key": "DTH", "value": "Đồng Tháp"},
            {"key": "GLA", "value": "Gia Lai"},
            {"key": "HGG", "value": "Hà Giang"},
            {"key": "HDU", "value": "Hải Dương"},
            {"key": "HPH", "value": "Hải Phòng"},
            {"key": "HNA", "value": "Hà Nam"},
            {"key": "HNO", "value": "Hà Nội (incl. Hà Tây)"},
            {"key": "HTI", "value": "Hà Tĩnh"},
            {"key": "HAU", "value": "Hậu Giang"},
            {"key": "HBI", "value": "Hòa Bình"},
            {"key": "HYE", "value": "Hưng Yên"},
            {"key": "KHO", "value": "Khánh Hòa"},
            {"key": "KGI", "value": "Kiên Giang"},
            {"key": "KTU", "value": "Kon Tum"},
            {"key": "LCH", "value": "Lai Châu"},
            {"key": "LDO", "value": "Lâm Đồng"},
            {"key": "LSO", "value": "Lạng Sơn"},
            {"key": "LCA", "value": "Lào Cai"},
            {"key": "LAN", "value": "Long An"},
            {"key": "NDI", "value": "Nam Định"},
            {"key": "NAN", "value": "Nghệ An"},
            {"key": "NBI", "value": "Ninh Binh"},
            {"key": "NTH", "value": "Ninh Thuận"},
            {"key": "PTH", "value": "Phú Thọ"},
            {"key": "PYE", "value": "Phú Yên"},
            {"key": "QBI", "value": "Quảng Bình"},
            {"key": "QNA", "value": "Quảng Nam"},
            {"key": "QNG", "value": "Quảng Ngãi"},
            {"key": "QNI", "value": "Quảng Ninh"},
            {"key": "STR", "value": "Sóc Trăng"},
            {"key": "QTR", "value": "Quảng Trị"},
            {"key": "SLA", "value": "Sơn La"},
            {"key": "TNI", "value": "Tây Ninh"},
            {"key": "TBI", "value": "Thái Bình"},
            {"key": "TNG", "value": "Thái Nguyên"},
            {"key": "THO", "value": "Thanh Hóa"},
            {"key": "TTH", "value": "Thừa Thiên-Huế"},
            {"key": "HCM", "value": "Thành Phố Hồ Chí Minh"},
            {"key": "TGI", "value": "Tiền Giang"},
            {"key": "TVI", "value": "Trà Vinh"},
            {"key": "TQU", "value": "Tuyên Quang"},
            {"key": "VLO", "value": "Vĩnh Long"},
            {"key": "VPH", "value": "Vĩnh Phúc"},
            {"key": "YBA", "value": "Yên Bái"}
        ]
    },
    "ZA": {
        "stateList": [
            {"key": "EC", "value": "Eastern Cape"},
            {"key": "FS", "value": "Free State"},
            {"key": "GT", "value": "Gauteng"},
            {"key": "KN", "value": "KwaZulu-Natal"},
            {"key": "LP", "value": "Limpopo"},
            {"key": "MP", "value": "Mpumalanga"},
            {"key": "NC", "value": "Northern Cape"},
            {"key": "NW", "value": "North West"},
            {"key": "WC", "value": "Western Cape"}
        ]
    }
};
